<template>
  <ul class="nav nav-tabs mb-4">
    <slot></slot>
  </ul>
</template>

<script setup lang="ts"></script>
